import { render, staticRenderFns } from "./ActiveAssignmentButton.vue?vue&type=template&id=0b85d4f1"
import script from "./ActiveAssignmentButton.vue?vue&type=script&lang=ts"
export * from "./ActiveAssignmentButton.vue?vue&type=script&lang=ts"
import style0 from "./ActiveAssignmentButton.vue?vue&type=style&index=0&id=0b85d4f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports